import request from '@/utils/request'

// post
export function postAction(url, parameter, headers = undefined) {
  return request({
    url: url,
    method: 'post',
    data: parameter,
    customHeaders: headers
  })
}

// post method= {post | put}
export function httpAction(url, parameter, method, headers = undefined) {
  return request({
    url: url,
    method: method,
    data: parameter,
    customHeaders: headers
  })
}

// put
export function putAction(url, parameter, headers = undefined) {
  return request({
    url: url,
    method: 'put',
    data: parameter,
    customHeaders: headers
  })
}

// get
export function getAction(url, parameter, headers = undefined) {
  return request({
    url: url,
    method: 'get',
    params: parameter,
    customHeaders: headers
  })
}

// deleteAction
export function deleteAction(url, parameter, headers = undefined) {
  return request({
    url: url,
    method: 'delete',
    params: parameter,
    customHeaders: headers
  })
}



// WEBPACK FOOTER //
// ./src/api/manage.js